"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Shield, HardHat, Building2 } from "lucide-react";
export default function BenvenutiInStudioMessSrl() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    icon: HardHat,
    title: "Sicurezza Cantieri",
    desc: "Coordinamento CSP/CSE in fase di esecuzione"
  }, {
    icon: Building2,
    title: "Progettazione Integrata",
    desc: "Soluzioni architettoniche e antincendio"
  }];
  return <section id="benvenuti-in-studio-mess-srl" className="relative min-h-[85vh] flex items-center justify-center py-24 overflow-hidden bg-background">
            {}
            <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/modern_architectural_site_hero.png')] bg-cover bg-center bg-no-repeat" />

            {}
            <div className="absolute inset-0 bg-primary/60 mix-blend-multiply" />
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/50 to-transparent" />

            {}
            <div className="container relative z-10 px-4 md:px-6 mx-auto">
                <div ref={textRef} className={`max-w-4xl mx-auto text-center transition-all duration-1000 transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                    <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 mb-8 text-sm font-semibold tracking-wider text-primary-foreground uppercase border rounded-full border-primary-foreground/20 bg-primary-foreground/10 backdrop-blur-md">
                        <Shield className="w-4 h-4 text-accent" />
                        <span>Studio MESS S.r.l.</span>
                    </div>

                    <h1 className="mb-6 text-4xl font-extrabold tracking-tight text-primary-foreground sm:text-5xl md:text-6xl lg:text-7xl">
                        Ingegneria, Sicurezza, <span className="text-accent">Innovazione</span>
                    </h1>

                    <p className="mb-10 text-lg leading-relaxed text-primary-foreground/90 sm:text-xl md:text-2xl max-w-3xl mx-auto font-light">Studio MESS S.r.l., con sede operativa a Monza e attivo su Milano e in tutta la Lombardia, nasce nel 2020 dall’esperienza del Per. Ind. Felice Mesuraca. <br />Lo Studio rappresenta oggi un punto di riferimento nella consulenza ingegneristica e nella sicurezza sul lavoro, supportando imprese e professionisti nella gestione completa degli obblighi normativi.<div data-ast-id="f:/src/pages/Studio/sections/BenvenutiInStudioMessSrl.tsx|sig:529pqh" data-ast-start="2811" data-ast-end="2828"><br /></div><div data-ast-id="f:/src/pages/Studio/sections/BenvenutiInStudioMessSrl.tsx|sig:528xk2" data-ast-start="2828" data-ast-end="3071">Fin dalla sua fondazione, l’obiettivo è stato quello di trasformare la complessità del quadro normativo in soluzioni tecniche concrete, efficienti e conformi al D.Lgs. 81/08, garantendo un approccio pratico e orientato ai risultati.</div></p>

                    <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
                        <Button asChild size="lg" className="w-full sm:w-auto bg-accent text-accent-foreground hover:bg-accent/90 border-none text-base h-12 px-8">
                            <Link to="/ServicesPage">
                                Scopri i Nostri Servizi
                            </Link>
                        </Button>
                        <Button asChild size="lg" variant="outline" className="w-full sm:w-auto text-primary-foreground border-primary-foreground/30 bg-primary-foreground/5 hover:bg-primary-foreground/10 hover:text-primary-foreground backdrop-blur-sm text-base h-12 px-8">
                            <Link to="/HomePage">
                                Torna alla Home
                            </Link>
                        </Button>
                    </div>

                    {}
                    
                </div>
            </div>
        </section>;
}